import React, { useRef, useState, useEffect, useCallback } from "react";
import MedicalCanvassing from "../../pages/MedicalCanvassing/MedicalCanvassing";
import RecordsRequest from "../../pages/RecordsRequest/RecordsRequest";
import SocialCanvassing from "../../pages/SocialCanvassing/SocialCanvassing";
import RequestorInformationForm from "../../pages/RequestorInformationForm/RequestorInformationForm";
import ClaimantForm from "../../pages/ClaimantForm/ClaimantForm";
import OrderReview from "../../pages/OrderReview/OrderReview";
import FormNavigation from "../FormNavigation/FormNavigation";
import axios from "axios";
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import FormStepper from "../FormStepper/FormStepper";
import * as Constants from "../../Constants"; 


export default function Steps({ steps, activeStep, setActiveStep, showModal }) {

  const medical_canvassing_step_number = steps.indexOf(Constants.MEDICAL_CANVASSING_STEP);
  const records_request_step_number = steps.indexOf(Constants.RECORDS_REQUEST_STEP);
  const social_canvass_step_number = steps.indexOf(Constants.SOCIAL_CANVASSING_STEP);
  const requestor_information_step_number = steps.indexOf(Constants.REQUESTOR_INFORMATION_STEP);
  const claimant_information_step_number = steps.indexOf(Constants.CLAIMANT_INFORMATION_STEP);
  const order_review_step_number = steps.indexOf(Constants.ORDER_REVIEW_STEP);
  

  const [uploadedFiles, setUploadedFiles] = useState(null);

  const [selectedMedicalCanvassOptions, setSelectedMedicalCanvassOptions] = useState([]);

  const [selectedRecordsRequestOption, setSelectedRecordsRequestOption] =
    useState(null);

  const handleCheckboxdRecordsRequestChange = (option) => {
    setSelectedRecordsRequestOption(selectedRecordsRequestOption?.id == option?.id ? null : option);
  };

  const [selectedSocialCanvassOptions, setSelectedSocialCanvassOptions] = useState([]);

  const onSocialCanvassChange = (options) => {
    setSelectedSocialCanvassOptions(options || []);
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [isExportDetailsValid, setExportDetailsValidation] = useState(true)

  const [formData, setFormData] = useState({
    socialCanvassing: {
      exportDetails: "",
    },
    medicalCanvassing: {
      other: "",
    },
    requestorInformation: {
      name: "",
      company: "",
      email: "",
      title: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phoneNumber: "",
      claimNumber: "",
      insuredClient: "",
      billToPhone: "",
      billToEmail: "",
      other: "",
    },
    claimantInformation: {
      ClaimantFirstName: "",
      ClaimantLastName: "",
      Alias: "",
      SSN: "",
      DateBirth: "",
      ClaimantAddress: "",
      city: "",
      state: "",
      zip: "",
      ClaimantEmail: "",
      Phone: "",
      EmployerName: "",
      EmployerAddress: "",
      EmployerCity: "",
      EmployerState: "",
      EmployerZip: "",
      EmployerPhone: "",
      EmployerContactName: "",
      ClaimantPosition: "",
      DateIncident: "",
      LastWorked: "",
      Nature: "",
      AdditionalComments: "",
      CoverageType: "",
      DueDate: "",
    },
  });

  const formRef = useRef(null);
  const claimantRef = useRef(null);

  const [selectedLocations, setSelectedLocations] = useState([
    { id: 1, title: "Hospital", isSelected: false, disabled: false },
    { id: 2, title: "Pharmacy", isSelected: false, disabled: false },
    { id: 3, title: "X-Ray / MRI", isSelected: false, disabled: false },
    { id: 4, title: "Doctor", isSelected: false, disabled: false },
    { id: 5, title: "Chiropractic", isSelected: false, disabled: false },
    {
      id: 6,
      title: "Health Clinic (Urgent Care)",
      isSelected: false,
      disabled: false,
    },
    { id: 7, title: "Mail Order Pharmacy", isSelected: false, disabled: false },
    { id: 8, title: "Dental", isSelected: false, disabled: false },
    { id: 9, title: "Orthopedic", isSelected: false, disabled: false },
    { id: 10, title: "Neurology", isSelected: false, disabled: false },
    {
      id: 11,
      title: "Optometry / Ophthalmology",
      isSelected: false,
      disabled: false,
    },
    { id: 12, title: "Cardiology", isSelected: false, disabled: false },
    { id: 13, title: "Podiatry", isSelected: false, disabled: false },
    { id: 14, title: "Physical Therapy", isSelected: false, disabled: false },
    {
      id: 15,
      title: "Clinical Laboratories",
      isSelected: false,
      disabled: false,
    },
    { id: 16, title: "Pain Management", isSelected: false, disabled: false },
    { id: 17, title: "Ear, Nose, Throat", isSelected: false, disabled: false },
    { id: 18, title: "Gym", isSelected: false, disabled: false },
    { id: 19, title: "Psychology", isSelected: false, disabled: false },
    { id: 20, title: "Psychiatric", isSelected: false, disabled: false },
    {
      id: 21,
      title: "Other (Explain Below)",
      isSelected: false,
      disabled: false,
    },
  ]);

  const handleCanvassByLocationTypeChange = (option) => {
    // Check if there is at least one location selected and the selected Medical Canvass Options contains the first and the second options
    if (
      selectedLocations.some((loc) => loc.isSelected) &&
      selectedMedicalCanvassOptions.some((opt) => opt.id === 0) &&
      selectedMedicalCanvassOptions.some((opt) => opt.id === 1)
    ) {
      setSelectedMedicalCanvassOptions((prevState) =>
        prevState.filter((item) => item.id === 0)
      );

      selectedLocations.forEach((loc) => {
        loc.isSelected = false;
      });
    }

    // Check if there is at least one location selected and the selected Medical Canvass Options contains the first option
    else if (
      selectedLocations.some((loc) => loc.isSelected) &&
      selectedMedicalCanvassOptions.some((opt) => opt.id === 1)
    ) {
      setSelectedMedicalCanvassOptions((prevState) =>
        prevState.filter((item) => item.id !== 1 && item.id !== 2)
      );

      selectedLocations.forEach((loc) => {
        loc.isSelected = false;
      });
    } 
    
    // Any other case
    else {
      setSelectedMedicalCanvassOptions((prevState) =>
        prevState.some((item) => item.id === option.id)
          ? prevState.filter((item) => item.id !== option.id && item.id !== 2)
          : [...prevState.filter((opt) => opt.id !== 2), option]
      );
    }
  }

  const onMedicalCanvassCheckboxChange = (option) => {
		// If the changed option is 'QuickTel Express Canvass'
		if (option?.id === 0) {
			setSelectedMedicalCanvassOptions((prevState) =>
				prevState.some((item) => item.id === option.id)
					? prevState.filter((item) => item.id !== option.id && item.id !== 2)
					: [...prevState.filter((opt) => opt.id !== 2), option]
			);
		}

		// If the changed option is 'Canvass by Location Type'
		else if (option?.id === 1) {
			handleCanvassByLocationTypeChange(option)
		}

		// If the changed option is 'I Do NOT Want a Medical Canvass Completed'
		else if (option?.id === 2) {
			// Check if the selected option is 'I Do NOT Want a Medical Canvass Completed' to remove it from the selected Medical Canvass Options
			if (selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
				setSelectedMedicalCanvassOptions((prevState) =>
					prevState.filter((item) => item.id !== 2)
				);
			}

			// Make 'I Do NOT Want a Medical Canvass Completed' is the only selected option
			else {
				setSelectedMedicalCanvassOptions([option]);
			}
		}
	};

  // Compare addresses
  const requestorAddress = {
    address: formData.requestorInformation.address?.toLowerCase().replaceAll(" ", ""),
    city: formData.requestorInformation.city?.toLowerCase().replaceAll(" ", ""),
    state: formData.requestorInformation.state?.toLowerCase().replaceAll(" ", ""),
    zip: formData.requestorInformation.zip?.toLowerCase().replaceAll(" ", ""),
  }
  const claimantAddress = {
    address: formData.claimantInformation.ClaimantAddress?.toLowerCase().replaceAll(" ", ""),
    city: formData.claimantInformation.city?.toLowerCase().replaceAll(" ", ""),
    state: formData.claimantInformation.state?.toLowerCase().replaceAll(" ", ""),
    zip: formData.claimantInformation.zip?.toLowerCase().replaceAll(" ", ""),
  }
  const isAddressInvalid = (requestorAddress.address !== "" && claimantAddress.address !== "") && JSON.stringify(requestorAddress) === JSON.stringify(claimantAddress)

  const [isMedicalCanvassingOk, setIsMedicalCanvassingOk] = useState(true);
  const handleSelectedLocations = (id, disabled) => {
    setSelectedLocations((prevLocations) =>
      prevLocations.map((location) =>
        location.id === id
          ? {
              ...location,
              isSelected: !location.isSelected,
              disabled: disabled,
            }
          : location
      )
    );
  };

  useEffect(() => {
    if (selectedMedicalCanvassOptions.some((opt) => opt.id === 0)) {
      selectedLocations[0].isSelected = false;
      selectedLocations[0].disabled = true;
      selectedLocations[1].isSelected = false;
      selectedLocations[1].disabled = true;
      setSelectedLocations(selectedLocations)
    } else {
      selectedLocations[0].disabled = false;
      selectedLocations[1].disabled = false;
      setSelectedLocations(selectedLocations)
    }

    if ((selectedMedicalCanvassOptions.some((opt) => opt.id === 2))) {
      selectedLocations.forEach(loc => {
        loc.isSelected = false
      })
    }
  }, [selectedMedicalCanvassOptions])
  
  const [receivedOrderViewModel, setReceivedOrderViewModel] = useState(null);

  const handleOrderViewModel = useCallback((orderViewModel) => {
    setReceivedOrderViewModel(orderViewModel);
  }, []);

  const saveFormDataToCookies = (data) => {
    const fieldsToSave = [
      "name",
      "company",
      "email",
      "title",
      "address",
      "city",
      "state",
      "zip",
      "phoneNumber",
    ];
    fieldsToSave.forEach((field) => {
      if (data[field]) {
        Cookies.set(field, data[field], { expires: 90 });
      }
    });
  };

  const [successSteps, setSuccessSteps] = useState([])

  const updateSuccessSteps = (step, addStep = true) => {
    if (addStep) {
      !successSteps.includes(step) && setSuccessSteps(prevState => [...prevState, step])
    } else {
      setSuccessSteps(prevState => [...prevState.filter(el => el !== step)])
    }
  }

  const handleNext = async () => {
    let canProceed = false;

    if (activeStep === medical_canvassing_step_number) {
      if (isMedicalCanvassingOk) {
        canProceed = true;
        updateSuccessSteps(activeStep)
      } else {
        canProceed = false;
        updateSuccessSteps(activeStep, false)
      };
    } else if (activeStep === records_request_step_number) {
      if (
        (selectedRecordsRequestOption?.id === 3 &&
          uploadedFiles?.recordsRequest !== null) ||
        selectedRecordsRequestOption?.id === 4
      ) {
        canProceed = true;
        updateSuccessSteps(activeStep)
      } else {
        canProceed = false;
        updateSuccessSteps(activeStep, false)
      };
    } else if (activeStep === social_canvass_step_number) {
      if (selectedSocialCanvassOptions.length !== 0 && (!selectedSocialCanvassOptions.some(opt => opt.id == 6 || opt.id == 7) || isExportDetailsValid)) {
        canProceed = true;
        updateSuccessSteps(activeStep)
      } else {
        canProceed = false;
        updateSuccessSteps(activeStep, false)
      };
    } else if (activeStep === requestor_information_step_number) {
      if (formRef.current && formRef.current.handleSubmit) {
        const isValid = formRef.current.handleSubmit();
        if (isValid) {
          saveFormDataToCookies(formData.requestorInformation)
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          updateSuccessSteps(activeStep);
        } else{
          updateSuccessSteps(activeStep, false);
        }
        setIsReqFormValid(isValid)        
      }
    } else if (activeStep === claimant_information_step_number) {
      if (claimantRef.current && claimantRef.current.handleSubmit) {
        const isValid = claimantRef.current.handleSubmit();
        if (isValid) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          updateSuccessSteps(activeStep);
        } else {
          updateSuccessSteps(activeStep, false);
        }
        setIsClmFormValid(isValid)       
      }
    }
    
    if (canProceed) {
      setShowError(false);
      setErrorMessage("");
      if (steps.includes(Constants.RECORDS_REQUEST_STEP) && selectedMedicalCanvassOptions.some((opt) => opt.id === 2) && activeStep === medical_canvassing_step_number) {
        setSelectedRecordsRequestOption({
          id: 4,
          title: "I Do NOT Want to Request Records Retrieval",
          description: "",
          features: [],
          header: "",
          locations: [],
        });
        setActiveStep(records_request_step_number + 1);
        updateSuccessSteps(records_request_step_number)
      } else setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (
      activeStep !== claimant_information_step_number &&
      activeStep !== requestor_information_step_number &&
      activeStep !== order_review_step_number &&
      ((!selectedMedicalCanvassOptions.length && activeStep === medical_canvassing_step_number) ||
        (selectedRecordsRequestOption == null && activeStep === records_request_step_number) ||
        (!selectedSocialCanvassOptions.length && activeStep === social_canvass_step_number))
    ) {
      setShowError(true);
      setErrorMessage("Choose one of the options above to proceed.");
    } else if (activeStep === steps.length - 1) {
      await saveOrderToBackend(receivedOrderViewModel);
    }
  };

  const [isPendingRequest, setIsPendingRequest] = useState(false);
  const saveOrderToBackend = async (orderViewModel) => {
    setIsPendingRequest(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/Orders`,
        orderViewModel,
        {}
      );
      showModal();
      return response;
    } catch (error) {
      showModal(error?.response?.data ?? "An unexpected error occurred!");
    } finally {
      setIsPendingRequest(false);
    }
  };

  const [isReqFormValid, setIsReqFormValid] = useState(false);
  const [isClmFormValid, setIsClmFormValid] = useState(false);

  useEffect(() => {
    if (activeStep === 3 && formRef.current && formRef.current.getFormStatus) {
      const isValid = formRef.current.getFormStatus();
      setIsReqFormValid(isValid)
    } else if (activeStep === 4 && claimantRef.current && claimantRef.current.getFormStatus) {
      const isValid = claimantRef.current.getFormStatus();
      setIsClmFormValid(isValid)
    }
  }, [activeStep, formData])

  const handleTabsSwitch = () => {
    let nextSuccessSteps = []

    if (isMedicalCanvassingOk) {
      updateSuccessSteps(medical_canvassing_step_number)
      nextSuccessSteps.push(medical_canvassing_step_number)

      if ( steps.includes(Constants.RECORDS_REQUEST_STEP) && selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setSelectedRecordsRequestOption({
          id: 4,
          title: "I Do NOT Want to Request Records Retrieval",
          description: "",
          features: [],
          header: "",
          locations: [],
        });
        updateSuccessSteps(records_request_step_number)
        nextSuccessSteps.push(records_request_step_number)
      }
    } else {
      updateSuccessSteps(medical_canvassing_step_number, false)
      nextSuccessSteps.filter(el => el !== medical_canvassing_step_number)
    }
    
    if (
      (selectedRecordsRequestOption?.id === 3 &&
        uploadedFiles?.recordsRequest !== null) ||
      selectedRecordsRequestOption?.id === 4
    ) {
        updateSuccessSteps(records_request_step_number);
        nextSuccessSteps.push(records_request_step_number)
    } else {
      updateSuccessSteps(records_request_step_number, false);
      nextSuccessSteps.filter(el => el !== records_request_step_number)
    }
  
    if (selectedSocialCanvassOptions.length !== 0) {
      updateSuccessSteps(social_canvass_step_number);
      nextSuccessSteps.push(social_canvass_step_number)
    } else {
      updateSuccessSteps(social_canvass_step_number, false);
      nextSuccessSteps.filter(el => el !== social_canvass_step_number)
    };
    
    if (activeStep === requestor_information_step_number && formRef.current && formRef.current.handleSubmit) {
      const isValid = formRef.current.handleSubmit();
      if (isValid) {
        saveFormDataToCookies(formData.requestorInformation);
        updateSuccessSteps(requestor_information_step_number);
      } else {
        updateSuccessSteps(requestor_information_step_number, false);
      }
      setIsReqFormValid(isValid)
    } 
    
    if (activeStep === claimant_information_step_number && claimantRef.current && claimantRef.current.handleSubmit) {
        const isValid = claimantRef.current.handleSubmit();
        if (isValid) {
          updateSuccessSteps(claimant_information_step_number)
        } else {
          updateSuccessSteps(claimant_information_step_number, false)
        }
        setIsClmFormValid(isValid);
      }

    if (
      activeStep !== requestor_information_step_number &&
      activeStep !== claimant_information_step_number &&
      activeStep !== order_review_step_number &&
      ((!selectedMedicalCanvassOptions.length && activeStep === medical_canvassing_step_number) ||
        (selectedRecordsRequestOption == null && activeStep === records_request_step_number) ||
        (!selectedSocialCanvassOptions.length && activeStep === social_canvass_step_number))
    ) {
      setShowError(true);
      setErrorMessage("Choose one of the options above to proceed.");
    }

    if (isReqFormValid) {
      updateSuccessSteps(requestor_information_step_number)
      nextSuccessSteps.push(requestor_information_step_number)
    } else {
      nextSuccessSteps.filter(el => el !== requestor_information_step_number)
    }
  
    if (isClmFormValid) {
        nextSuccessSteps.push(claimant_information_step_number)
    } else {
      nextSuccessSteps.filter(el => el !== claimant_information_step_number)
    }

    return nextSuccessSteps
  };

  const handleBack = () => {    
    let backSuccessSteps = []

    if (activeStep === records_request_step_number) {
      if (
        (selectedRecordsRequestOption?.id === 3 &&
          uploadedFiles?.recordsRequest !== null) ||
        selectedRecordsRequestOption?.id === 4
      ) {
        updateSuccessSteps(records_request_step_number)
        backSuccessSteps.push(records_request_step_number)
      } else {
        updateSuccessSteps(records_request_step_number, false)
        backSuccessSteps.filter(el => el !== records_request_step_number)
      }
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else if (activeStep === social_canvass_step_number) {
      if (selectedSocialCanvassOptions.length !== 0 && selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setActiveStep(medical_canvassing_step_number)
        updateSuccessSteps(social_canvass_step_number)
        backSuccessSteps.push(social_canvass_step_number)
      } else if (selectedSocialCanvassOptions.length !== 0 && !selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        updateSuccessSteps(social_canvass_step_number);
        backSuccessSteps.push(social_canvass_step_number)
      } else if (!selectedSocialCanvassOptions.length && selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setActiveStep(medical_canvassing_step_number);
        updateSuccessSteps(social_canvass_step_number, false);
        backSuccessSteps.filter(el => el !== social_canvass_step_number)
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        updateSuccessSteps(social_canvass_step_number, false);
        backSuccessSteps.filter(el => el !== social_canvass_step_number)
      };
    } else if (activeStep === requestor_information_step_number && formRef.current && formRef.current.getFormStatus) {
      const isValid = formRef.current.getFormStatus();
      if (isValid) {
        updateSuccessSteps(requestor_information_step_number);
        backSuccessSteps.push(requestor_information_step_number)
      } else {
        updateSuccessSteps(requestor_information_step_number, false);
        backSuccessSteps.filter(el => el !== requestor_information_step_number)
      }
      setIsReqFormValid(isValid)
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else if (activeStep === claimant_information_step_number && claimantRef.current && claimantRef.current.getFormStatus) {
      const isValid = claimantRef.current.getFormStatus();
      if (isValid) {
        updateSuccessSteps(claimant_information_step_number);
        backSuccessSteps.push(claimant_information_step_number)
      } else {
        updateSuccessSteps(claimant_information_step_number, false);
        backSuccessSteps.filter(el => el !== claimant_information_step_number)
      }
      setIsClmFormValid(isValid)
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else if (activeStep === order_review_step_number) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    return backSuccessSteps
  };

  useEffect(() => {
    if (
      (activeStep === medical_canvassing_step_number && isMedicalCanvassingOk) ||
      (activeStep === records_request_step_number &&
        selectedRecordsRequestOption?.id === 3 &&
        uploadedFiles?.recordsRequest !== null) ||
      (activeStep === records_request_step_number && selectedRecordsRequestOption?.id === 4) ||
      (activeStep === social_canvass_step_number && selectedSocialCanvassOptions.length !== 0) ||
      (selectedMedicalCanvassOptions && activeStep === medical_canvassing_step_number) ||
      (selectedRecordsRequestOption !== null && activeStep === records_request_step_number) ||
      (selectedSocialCanvassOptions.length !== 0 && activeStep === social_canvass_step_number)
    ) {
      setShowError(false);
      setErrorMessage("");
    }
  }, [
    activeStep,
    selectedMedicalCanvassOptions,
    selectedLocations,
    selectedRecordsRequestOption,
    selectedSocialCanvassOptions,
    isMedicalCanvassingOk,
    uploadedFiles,
  ]);

  return (
    <>
      <FormStepper
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        handleTabsSwitch={handleTabsSwitch}
        handleBack={handleBack}
        successSteps={successSteps}
        isMedicalCanvassDoNot={selectedMedicalCanvassOptions.some((opt) => opt.id === 2)}
      />
      <Box sx={{ flexDirection: "row", pt: 5 }}>
        {activeStep === medical_canvassing_step_number ? (
          <MedicalCanvassing
            selectedMedicalCanvassOptions={selectedMedicalCanvassOptions}
            setSelectedMedicalCanvassOptions={setSelectedMedicalCanvassOptions}
            onMedicalCanvassCheckboxChange={onMedicalCanvassCheckboxChange}
            updateLocations={handleSelectedLocations}
            selectedLocations={selectedLocations}
            onUploadFile={setUploadedFiles}
            uploadedFiles={uploadedFiles}
            setIsMedicalCanvassingOk={setIsMedicalCanvassingOk}
            formData={formData.medicalCanvassing}
            setFormData={setFormData}
          />
        ) : activeStep === records_request_step_number ? (
          <RecordsRequest
            selectedRecordsRequestOption={selectedRecordsRequestOption}
            handleCheckboxdRecordsRequestChange={
              handleCheckboxdRecordsRequestChange
            }
            onUploadFile={setUploadedFiles}
            uploadedFiles={uploadedFiles}
          />
        ) : activeStep === social_canvass_step_number ? (
          <SocialCanvassing
            selectedSocialCanvassOptions={selectedSocialCanvassOptions}
            exportDetailsVal={formData.socialCanvassing.exportDetails}
            onSocialCanvassChange={onSocialCanvassChange}
            onExportDetailsChange={(v, isValid) => {setFormData({ ...formData, socialCanvassing: { exportDetails: v } }); setExportDetailsValidation(isValid)}}
          />
        ) : activeStep === requestor_information_step_number ? (
          <RequestorInformationForm
            formData={formData.requestorInformation}
            isAddressInvalid={isAddressInvalid}
            setFormData={setFormData}
            ref={formRef}
          />
        ) : activeStep === claimant_information_step_number ? (
          <ClaimantForm
            formData={formData.claimantInformation}
            isAddressInvalid={isAddressInvalid}
            setFormData={setFormData}
            ref={claimantRef}
            onUploadFile={setUploadedFiles}
            uploadedFiles={uploadedFiles}
          />
        ) : (
          <div>
            <OrderReview
              formData={formData}
              selectedMedicalCanvassOptions={selectedMedicalCanvassOptions}
              selectedRecordsRequestOption={selectedRecordsRequestOption}
              selectedSocialCanvassOptions={selectedSocialCanvassOptions}
              uploadedFiles={uploadedFiles}
              selectedLocations={selectedLocations}
              onOrderViewModel={handleOrderViewModel}
            />
          </div>
        )}
      </Box>

      <FormNavigation
        steps={steps}
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        showError={showError}
        errorMessage={errorMessage}
        isPendingRequest={isPendingRequest}
      />
    </>
  );
}
